import { useFormContext } from 'react-hook-form';
import { countryList } from '~/components/gis/countryList';
import { Select } from '~/components/ui/forms/select';
import { TextInput } from '~/components/ui/forms/text-input';
import { TinyMceInput } from '~/components/ui/forms/tinymce-input';
import type { RegionFormValues } from '~/utils/modules/region';

export function RegionFormFields() {
  const { register } = useFormContext<RegionFormValues>();

  return (
    <div className="space-y-2">
      <TextInput {...register('name')} label="Name" required />
      <TinyMceInput {...register('description')} label="Description" required />
      <TinyMceInput {...register('basins')} label="Basins" required />
      <TextInput {...register('location')} label="Location" required />
      <Select
        {...register('country')}
        label="Country"
        required
        options={countryList}
      />
    </div>
  );
}
